<style lang="scss" scoped>
.notice-popup-wrap {
  z-index: 999;
  width: 100%;
  top: 0px;
  left: 0;
  height: 100%;
  text-align: center;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}
.notice-popup {
  width: 346px;
  min-height: 402px;
  border-radius: 12px;
  background-color: #fff;
  padding: 16px 22px;
}
.tophandle {
  display: flex;
  justify-content: flex-end;
  .iconfont {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
  }
}
.combined {
  height: 80px;
}
.messageTitle {
  font-size: 21px;
  color: #3b3b4d;
  margin: 12px 0 8px;
  word-break: break-all;
  font-weight: 600;
}
.messageContent {
  margin-bottom: 20px;
  height: 130px;
  overflow: auto;
  text-align: start;
}
.handle {
  height: 42px;
  border-radius: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  width: 70%;
  margin: 0 auto;
}
</style>
<template>
  <div class="notice-popup-wrap" v-if="showMailModal">
    <div class="notice-popup" :class="showMailModal && 'showAnima'">
      <div class="tophandle">
        <i @click="$store.commit('user/setShowReadMsg', false)" class="iconfont guanbi1"></i>
      </div>
      <div v-show="!loading">
        <img class="combined" src="@img/public/combined.png" alt="" />
        <div class="messageTitle">
          {{ list[index] && list[index].messageTitle }}
        </div>
        <div class="messageContent" id="mail-pop-editor-html" v-html="content"></div>
        <div  
          v-if="index + 1 < list.length"
          @click="index + 1 < list.length && switchIndex(index + 1)"
          class="handle"
          :style="
            `background-color:${$vuetify.theme.themes.light.buttonColor ||
              $vuetify.theme.themes.light.headerBgColor};color:${$vuetify.theme.themes.light.front}`
          "
        >
          下一条
        </div>
        <div
          v-else
          @click="$store.commit('user/setShowReadMsg', false)"
          class="handle"
          :style="
            `background-color:${$vuetify.theme.themes.light.buttonColor ||
              $vuetify.theme.themes.light.headerBgColor};color:${$vuetify.theme.themes.light.front}`
          "
        >
          知道了
        </div>
      </div>
      <div v-show="loading" class="loading">努力加载中···</div>
    </div>
  </div>
</template>
<script>
import { ApigetNoReadAndIsPopMsg, ApiMessageReadByIds } from '@api/service'
export default {
  data: function() {
    return {
      list: [],
      index: 0,
      loading: true
    }
  },
  computed: {
    showMailModal() {
      return this.$store.state.user.showReadMsg
    },
    noReadMsgCount() {
      return this.$store.state.user.noReadMsgCount
    },
    content() {
      return this.list[this.index] && this.list[this.index].content
    }
  },
  methods: {
    switchIndex(index) {
      this.index = index
      ApiMessageReadByIds([this.list[index].messageId])
    }
  },
  watch: {
    async showMailModal() {
      if (this.showMailModal == true) {
        this.loading = true
        const res = await ApigetNoReadAndIsPopMsg()
        this.loading = false
        if (res.code == '12200') {
          this.list = res.data.list
          this.switchIndex(0)
          this.$nextTick(() => {
            window.uParse('#mail-pop-editor-html', {
                rootPath: this._cdn + '/pc/common/Ueditor/third-party'
            })
          })
        }
      }
    }
  },
  beforeCreate() {
    this.$store.commit('user/setShowReadMsg', false)
  }
}
</script>